export default "__VITE_ASSET__CgSzcqR4__"